import { useState } from "react";
import { Loader2, LockKeyhole } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { AlpanaDivider } from "@/components/tss/Ornaments";

export default function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/admin/login", { password });
      onLogin();
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="hero-placeholder grain grid min-h-screen place-items-center px-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="relative z-10 w-full max-w-sm rounded-3xl border border-gold/40 bg-[#1C100B]/80 p-7 text-ivory shadow-2xl backdrop-blur-xl">
        <LockKeyhole className="h-8 w-8 text-gold" />
        <h1 className="mt-4 font-display text-3xl font-bold">Organiser console</h1>
        <p className="mt-1 text-sm text-ivory/70">TSS Sharod Shamman 2026</p>
        <AlpanaDivider className="my-5" />
        <label className="text-xs font-semibold uppercase tracking-wider text-gold-light" htmlFor="admin-pass">Password</label>
        <input
          id="admin-pass"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-login-pass-input"
          className="mt-2 h-12 w-full rounded-xl border border-gold/40 bg-white/10 px-4 text-ivory outline-none focus:border-gold focus:ring-2 focus:ring-gold/30"
        />
        {error && <p data-testid="admin-login-error" className="mt-3 text-sm text-red-300">{error}</p>}
        <button type="submit" disabled={busy || !password} data-testid="admin-login-submit-btn" className="mt-5 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-gold font-semibold text-maroon-deep transition-[background-color,transform] hover:bg-gold-light active:scale-95 disabled:opacity-50">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </main>
  );
}
